import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonList,
  IonRow,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { UUID } from '@okcargo-apps/shared-domain';
import { ECapabilities, EInvoiceState, EInvoiceType } from '@okcargo-apps/shared-domain-ionic';
import { ConnectivityService } from '@okcargo-apps/shared-infrastructure';
import { DateFnsModule } from 'ngx-date-fns';
import { Observable, Subscription } from 'rxjs';
import { AccountService } from '../../account/account.service';
import { DownloadDocumentService } from '../../download-document/download-document.service';
import { InvoiceService } from '../invoice.service';

@Component({
  selector: 'lib-invoices-list',
  templateUrl: './invoices-list.component.html',
  styleUrls: ['./invoices-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IonItemDivider,
    IonItemGroup,
    CommonModule,
    IonIcon,
    IonButton,
    IonCol,
    IonRow,
    IonGrid,
    IonLabel,
    IonItem,
    IonList,
    TranslateModule,
    DateFnsModule,
  ],
})
export class InvoicesListComponent implements OnInit {
  private readonly invoiceService = inject(InvoiceService);
  private readonly accountService = inject(AccountService);
  private readonly downloadDocumentService = inject(DownloadDocumentService);
  private readonly connectivity = inject(ConnectivityService);

  /** Downloading an invoice queries the backend: it cannot be done without connection. */
  protected readonly isOffline = this.connectivity.isOffline;

  @Input()
  type: EInvoiceType = EInvoiceType.PURCHASE;

  @Input()
  latest = false;

  isDesktopView$: Subscription = new Subscription();
  public isDesktop = false;

  public readonly EInvoiceType = EInvoiceType;
  public readonly EInvoiceState = EInvoiceState;

  public account = this.accountService.account;
  protected readonly canAdministrativeDocuments = computed(() =>
    this.accountService.hasCapability(ECapabilities.ADMINISTRATIVE_DOCUMENTS),
  );

  public invoices$!: Observable<any>;

  // constructor() {}

  ngOnInit(): void {
    // we make sure we receive the value of @Input
    if (this.type === EInvoiceType.SALE) {
      this.invoices$ = this.invoiceService.invoicesSale$;
    } else {
      this.invoices$ = this.invoiceService.invoicesPurchase$;
    }
  }

  protected download(documentId: UUID): void {
    if (this.isOffline()) return;

    this.downloadDocumentService.downloadFile(
      this.downloadDocumentService.getDownloadDocumentURL(documentId),
      'factura_',
    );
  }
}
